import { render, staticRenderFns } from "./DataTransfersFlowChart.vue?vue&type=template&id=71c70d49"
import script from "./DataTransfersFlowChart.vue?vue&type=script&lang=js"
export * from "./DataTransfersFlowChart.vue?vue&type=script&lang=js"
import style0 from "./DataTransfersFlowChart.vue?vue&type=style&index=0&id=71c70d49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports